// Import necessary components and libraries
import { MissingDataSource } from 'components/helpers/EditingHelpText';
import HeadingWrapper from 'components/helpers/HeadingWrapper/HeadingWrapper';
import PlaceholderWrapper from 'components/helpers/PlaceholderWrapper/PlaceholderWrapper';
import { FullWidthVideoPromoProps } from './FullWidthVideoPromo';
import CtaGroup from 'components/helpers/CtaGroup/CtaGroup';

const FullWidthVideoPromoOverlay = ({
  fields,
  rendering,
}: FullWidthVideoPromoProps): JSX.Element => {
  // Return a placeholder if fields are missing
  if (!fields) {
    return <MissingDataSource />;
  }

  return (
    <>
      {/* Render the heading with specific styles */}
      <HeadingWrapper {...fields} defaultHeadlinePosition="left" />
      {/* Render additional content placeholder */}
      <PlaceholderWrapper
        wrapperSize="half"
        name="BCBSAZ-Additional-Content"
        rendering={rendering}
      />
      {/* Render the CTA group */}
      <div className="mt-6 md:mt-6 md:mr-0">
        <CtaGroup {...fields} />
      </div>
    </>
  );
};

export default FullWidthVideoPromoOverlay;
